module.exports = __webpack_public_path__ + "static/matt-829230b858a2689d728e79f2e8002d40.jpg";